import axios from "axios";
import { API_CONFIG } from "../utils/constants";

const raw = axios.create({
  baseURL: `${String(API_CONFIG.BASE_URL).replace(/\/$/, "")}/api`,
  headers: { "Content-Type": "application/json" },
});

let pending = null;

export function storeSession({ token, refreshToken, sessionId }) {
  if (token) localStorage.setItem("token", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  if (sessionId) localStorage.setItem("sessionId", sessionId);
  window.dispatchEvent(new Event("bremar-token"));
}

export function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("sessionId");
}

async function exchange(refreshToken) {
  const res = await raw.post("/auth/refresh", { refreshToken });
  const body = res.data || {};
  const token = body.token || body.accessToken || body.data?.accessToken;
  const nextRefresh = body.refreshToken || body.data?.refreshToken;
  if (!token || !nextRefresh) throw new Error("Refresh vacío");
  storeSession({ token, refreshToken: nextRefresh });
  return token;
}

export function refreshSession() {
  if (pending) return pending;
  pending = (async () => {
    const sent = localStorage.getItem("refreshToken");
    if (!sent) throw Object.assign(new Error("Sin refresh"), { staleRefresh: sent });
    try {
      return await exchange(sent);
    } catch (err) {
      await new Promise((resolve) => setTimeout(resolve, 400));
      const current = localStorage.getItem("refreshToken");
      if (current && current !== sent) return exchange(current);
      err.staleRefresh = sent;
      throw err;
    }
  })().finally(() => {
    pending = null;
  });
  return pending;
}
